<template>
    <div class="story-form-post-creator hide-scrollbar">
        <section class="publish-date">
            <label>Date de publication <span v-if="updateFormData.planifiedDate" @click="$emit('restoreFormData','planifiedDate')" class="restore">Annuler les modifications</span></label>
            <div class="content-section">
                <SelectComponent :changeValueSelect="changeSelectPublishDate" :data="{now:'Maintenant',flanified:'Planifier'}" :valueSelect="!formData.planifiedDate.date ? 'now' : 'flanified'" :positionAuto="false" :positionX="'left'"></SelectComponent>
                <div class="input-date" v-if="formData.planifiedDate.date">        
                    <p>{{ formatInputDatePicker }}</p>
                    <i class="fa-regular fa-calendar"></i>
                    <input type="date" v-model="formData.planifiedDate.date" :disabled="formData.planifiedDate.date ? false : true" @click="(e)=>e.target.showPicker()" :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')">
                </div>
                <div class="input-hours" v-if="formData.planifiedDate.hours !== false">
                    <input type="text" v-model="formData.planifiedDate.hours" @blur="comptetePlanifiedDateHours()">
                    <i class="fa-regular fa-clock"></i>
                </div>
            </div>
        </section>
   
        <section class="content-media">
            <label>Arriere plan <span v-if="updateFormData.files" @click="$emit('restoreFormData','files')" class="restore">Annuler les modifications</span></label>
            <div class="container-medias">
                <input
                    v-validate="''"
                    name="file"
                    type="file"
                    id="file"
                    ref="inputMediaStory"
                    @change="upluadBackgroundFile"
                    :multiple="false"
                    @click="()=>{}"
                    :accept="'.jpg, .jpeg, .png, .mp4'" 
                    hidden
                >         
                <!-- .avi, .mov, .mkv -->

                <div class="btn-color" @click="()=>{colorPickerShow = true; showPipette = true}" :style="{backgroundColor:formData.storification.background.color}">
                    <div class="picker-color" v-if="colorPickerShow" @mouseleave="colorPickerShow = false" @mousedown="showPipette = false">
                        <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                        <chrome-picker :value="{hex:formData.storification.background.color}" @input="updateFromPicker"/>
                    </div>
         
                </div>

                <template v-if="formData.storification.background.file">
                    <div class="media-container picture" v-if="['image/png','image/jpeg','image/gif'].includes(formData.storification.background.file.file.type)" @click="openBackgroundResizeMode">
                        <i class="fa-solid fa-circle-xmark" @click="removeBackgroundFile"></i>
                        <div class="media picture">
                            <img draggable="false" :src="formData.storification.background.file.url" alt="" class="source">
                        </div>
                    </div>

                    <div class="media-container video" v-else-if="['video/mp4'].includes(formData.storification.background.file.file.type)" @click="openBackgroundResizeMode">
                        <i class="fa-solid fa-circle-xmark" @click="removeBackgroundFile"></i>
                        <div class="media video"> 
                        
                            <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true">
                                <source :src="formData.storification.background.file.url" type="video/mp4">
                            </video>

                            <!-- <img v-if="media.imagePreview" :src="media.imagePreview.url" alt="" class="preview" draggable="false" @click="clickBtnAddVideoPreview(media.id)">
                            <video v-else muted playsinline preload="metadata" class="preview" @click="clickBtnAddVideoPreview(media.id)" onloadedmetadata="this.muted = true">
                                <source :src="media.url" type="video/mp4">
                            </video> -->
                        </div>
                    </div>
                </template>
                

                <div class="btn-add-media" v-else>
                    <ContextMenu :options="[{label:'Ajouter une url',name:'link'},{label:'Importer des fichiers',name:'file'}]" :id="'btnAddMediaPostCreator'" v-on:clickOption="clickBtnAddMedia">
                        <i class="fa-solid fa-photo-film"></i>
                    </ContextMenu>
                </div>


            </div>
        </section>

        <section class="content-stickers">
            <label>Stickers</label>
            <div class="container-stickers">
                <draggable class="list-stickers hide-scrollbar" ref="listStickers" v-model="stickersSortByZIndex" v-bind="dragOptions" @start="drag=true" @end="()=> {drag=false; moveSticker()}" :filter="'.lockdrag'">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        
                        <template v-for="sticker in stickersSortByZIndex" >
                            <div v-if="sticker.id == 'btnAdd'" @click="openMenuStickers" class="btn-add-sticker lockdrag" :class="{'no-drag' : drag}" :key="'btnAdd'">
                                <svg width="auto" height="auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 0H31.3333C38.3289 0 44 5.67106 44 12.6667V25.1242C44 26.5387 43.4381 27.8952 42.4379 28.8954L28.8954 42.4379C27.8952 43.4381 26.5387 44 25.1242 44H12.6667C5.67106 44 0 38.3289 0 31.3333V12.6667C0 5.67106 5.67106 0 12.6667 0ZM12.6667 4C7.8802 4 4 7.8802 4 12.6667V31.3333C4 36.1198 7.8802 40 12.6667 40H25.3333L40 25.3333V12.6667C40 7.8802 36.1198 4 31.3333 4H12.6667Z" fill="#F1EDF5"/>
                                    <path d="M35.334 23.334H43.334L41.334 27.334H35.334C30.9157 27.334 27.334 30.9157 27.334 35.334V40.6673L23.334 41.334V35.334C23.334 28.7066 28.7066 23.334 35.334 23.334Z" fill="#F1EDF5"/>
                                    <path d="M16.6673 18.0007C16.6673 19.4734 15.4734 20.6673 14.0007 20.6673C12.5279 20.6673 11.334 19.4734 11.334 18.0007C11.334 16.5279 12.5279 15.334 14.0007 15.334C15.4734 15.334 16.6673 16.5279 16.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path d="M32.6673 18.0007C32.6673 19.4734 31.4734 20.6673 30.0007 20.6673C28.5279 20.6673 27.334 19.4734 27.334 18.0007C27.334 16.5279 28.5279 15.334 30.0007 15.334C31.4734 15.334 32.6673 16.5279 32.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9633 26.2096C13.7676 25.4526 15.0334 25.4909 15.7904 26.2953C17.9806 28.6224 20.4661 29.1591 22.4662 29.1247C23.4806 29.1072 24.3615 28.9402 24.986 28.7775C25.2962 28.6967 25.5372 28.6185 25.6927 28.5638C25.7703 28.5365 25.8261 28.5152 25.8581 28.5027C25.874 28.4965 25.884 28.4924 25.8876 28.4909L25.8852 28.492L25.8826 28.4931M25.8881 28.4907C26.9014 28.062 28.0717 28.5325 28.5056 29.5448C28.9407 30.5601 28.4704 31.7359 27.4552 32.171L26.675 30.3507C27.4552 32.171 27.4543 32.1714 27.4534 32.1718L27.4514 32.1726L27.4469 32.1745L27.4361 32.1791L27.4065 32.1913C27.3834 32.2008 27.3534 32.2129 27.3168 32.2273C27.2435 32.2559 27.1437 32.2936 27.0195 32.3373C26.7715 32.4245 26.4239 32.5364 25.9945 32.6483C25.1398 32.871 23.9374 33.0999 22.5351 33.1241C19.7019 33.1729 16.0207 32.3763 12.8776 29.0368C12.1206 28.2324 12.1589 26.9667 12.9633 26.2096M25.8881 28.4907C25.888 28.4908 25.8878 28.4909 25.8876 28.4909L25.8884 28.4906L25.8892 28.4903C25.889 28.4904 25.8887 28.4905 25.8881 28.4907Z" fill="#F1EDF5"/>
                                </svg>
                            </div>
                            <div v-else class="stricker" :class="{'lockdrag' : sticker.type == 'music'}" :key="sticker.id">
                                <i class="fa-solid fa-circle-xmark" @click.stop="deleteSticker(sticker.id)"></i>
                                <div class="sticker-view">
                                    <div v-if="sticker.type == 'music'" class="music">
                                        <div class="disk">
                                            <img :src="sticker.data.music.track.cover_artwork_thumbnail_uri">
                                        </div>
                                    
                                    </div>
                                    <stickerWrapper v-else
                                        :sticker="{...sticker, isEditing: false}"
                                    />
                                </div>
                                <p class="sticker-type">{{sticker.type}}</p>
                            </div>
                        </template >
                       
                    </transition-group>
                </draggable>
            </div>
        </section>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from './../../../store/index.js';
import SelectComponent from '../utils/select.vue'
import Editor from './Editor.vue'
import ComponentSwitch from '../utils/switch.vue'
import Checkbox from '../utils/checkbox.vue'
import SnippetNetwork from './SnippetNetwork.vue'
import ContextMenu from '../contextMenu/contextMenuInit.vue'
import draggable from 'vuedraggable'
import minxinBot from '../../mixins/Bots.vue'
import minxinPosts from '../../mixins/Posts.vue'
import { getDocument } from 'pdfjs-dist';
import { formDataDefault } from './constante.js'
import Tooltip from './../tooltip/tooltipInit.vue'
import stickerWrapper from './storyMaker/stiker/stickerWrapper.vue';
import { Chrome } from 'vue-color'

// import * as pdfjsLib from 'pdfjs-dist/webpack';

// // Configure the workerSrc to use the correct version of the worker script
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js`;


export default {
    mixins: [minxinBot, minxinPosts],
    components: {
        Editor,
        SelectComponent,
        ComponentSwitch,
        SnippetNetwork,
        Checkbox,
        Tooltip,
        ContextMenu,
        draggable,
        stickerWrapper,
        'chrome-picker': Chrome,
    },
    props: {
        typeRenderNetworkSelected: {
            type: String,
            default: 'facebook'
        },

        idPageRenderNetworkSelected: String,

        formData :  Object,
        
        updateFormData : {
            type: Object,
            default: () => ({})
        },

        uniqueNetworkForm : {
            type: Boolean,
            default: false
        },

        uploadFilesServer : {
            type: Object,
            default: () => ({})
        },

        networksSelected : {
            type: Set,
            default: () => (new new Set([]))
        },
    },

    data() {
        return {
            lastModeSelected : undefined,
            drag : false,
            timeoutVerifMetaUrl: null,

            stickersSortByZIndex : [],

            eyeDropperIsAccess : false,
            colorPickerShow: false,
            colorPickerShow: false,
            showPipette: false,
        }
    },

    created () {
        console.log('created form formdata ', this.formData)
    },

    mounted () {
       this.sortStickers()
       this.eyeDropperIsAccess = window.EyeDropper ? true : false
    },


    methods: {
        addMode(mode, data = {}) {
            this.lastModeSelected = mode
            EventBus.$emit("postCreatorAddMode", mode, data);
        },
            
        changeSelectPublishDate(value) {
            if (!this.date && value == "flanified") {
                let date = new Date((new Date).getTime() + 3600000)
                this.$set(this.formData.planifiedDate, 'date', date.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'));
                this.$set(this.formData.planifiedDate, 'hours', date.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join('h'));
            }else if(value == "now") {
                this.$set(this.formData.planifiedDate, 'date',false)
                this.$set(this.formData.planifiedDate, 'hours', false)
            }  
            

            this.$emit('saveFormData')


        },


        clickBtnAddMedia(id, value) {

            switch (value) {
                case 'link':
                    
                    break;
            
                case 'file':
                    this.$refs.inputMediaStory.click()
                    break;
            }
        },

        upluadBackgroundFile(event) {
            const file = event.target.files[0];
            if (file) {
                console.log('file',file)
                this.$set(
                    this.formData.storification.background, 
                    'file', 
                    {
                        file: file,
                        url: URL.createObjectURL(file),
                    }
                ) 
                this.openBackgroundResizeMode()
            }
        },
 
        removeBackgroundFile(id) {
            this.$set(
                this.formData.storification, 
                'background', 
                {
                    file : null,
                    color : this.formData.storification.background.color,
                    size : 'containX',
                    position: {"x":50,"y":50},
                    transform: {"rotate":0,"scale":1}
                }
            ) 

        },


        makeThumb(page) {
            // draw page to fit into 96x96 canvas
            var vp = page.getViewport({ scale: 1, });
            var canvas = document.createElement("canvas");
            var scalesize = 1;
            canvas.width = vp.width * scalesize;
            canvas.height = vp.height * scalesize;
            var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);

            return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
                return canvas; 
            });
        },


        clickBtnAddVideoPreview(id) {
            this.$refs.inputVideoPreview.setAttribute('idMedia', id)
            this.$refs.inputVideoPreview.click()
        },

        selectVideoPreview(e) {
   
            let idFile = e.target.getAttribute('idMedia')

            this.$set(this.formData, 'files', this.formData.files.map((file) => {
                if (file.id !== idFile) return file;

                file.imagePreview = {
                    url: URL.createObjectURL(e.target.files[0]),
                    name: e.target.files[0].name,
                    type: e.target.files[0].type,
                    size: e.target.files[0].size,
                    id: Math.random().toString(36).substr(2, 9),
                    // ratio: this.carrouselRatio,
                }
                this.$emit('updloadFile', e.target.files[0], file.imagePreview.id)
                return file
            }));
            //this.$emit('saveFormData')  dans le watch
        },

        comptetePlanifiedDateHours() {
            let tab = [...this.formData.planifiedDate.hours.split('h').filter(e => e.length),'00','00']
            tab[1] = tab[1].padStart(2, '0') + "0"
            this.formData.planifiedDate.hours = tab.slice(0,2).join('h')
        },
        
        calculTimeStampPlanifiedDate() {
            let date = new Date(this.formData.planifiedDate.date)
            if (this.formData.planifiedDate.hours.includes("h")) {
                let [hours,minute] = [...this.formData.planifiedDate.hours.split('h').filter(e=>e.length),'00','00'].slice(0,2)
                date.setMinutes(minute)
                date.setHours(hours)
            }

            this.$set(this.formData.planifiedDate, 'timestamp', date.getTime());
            this.$emit('saveFormData')
        },

        setFormDataNetwork(typeNetwork, data) {
            console.log('setFormDataNetwork',typeNetwork, this.uniqueNetworkForm)
            if (this.uniqueNetworkForm && typeNetwork !== this.typeRenderNetworkSelected) return
            this.$set(this.formData.formDataNetwork, typeNetwork, data);
            this.$emit('saveFormData')
        },

        async fileToArrayBuffer(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    let arrayBuffer = new Uint8Array(reader.result);
                    resolve(arrayBuffer)
                }

                reader.readAsArrayBuffer(file);
            });
        },

        sortStickers() {
            this.stickersSortByZIndex = [{id:'btnAdd'}, ...Object.values(this.formData.storification.stickers).sort((a,b)=> parseFloat(b.type == 'music' ? 1 : b.zIndex) - parseFloat(a.zIndex))]
        },

        moveSticker(e, a,c) {
  
            this.$set(
                this.formData.storification, 
                'stickers', 
                this.stickersSortByZIndex
                    .filter(sticker => sticker.id !== 'btnAdd')
                    .reduce((acc, sticker, index) => ({
                        ...acc,
                        [sticker.id]: {
                        ...sticker,
                        zIndex: this.stickersSortByZIndex.length - index,
                        }
                    }), {})
            ) 
            EventBus.$emit("storyMaker-setOverlay", false)
        },

        deleteSticker(id) {
            this.$delete(this.formData.storification.stickers, id)         
        },

        openBackgroundResizeMode() {
            EventBus.$emit("storyMaker-setOverlay", 'backgroundResize')
        },

        openMenuStickers() {
            EventBus.$emit("storyMaker-setOverlay", 'stickers')
        },

        updateFromPicker(value) {
            this.$set(this.formData.storification.background, 'color', value.hex)
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            this.colorPickerShow = false
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.$set(this.formData.storification.background, 'color', result.sRGBHex)
            }).catch((e) => {
            });
        },
    },

    computed: {
        console: () => console,

        formatInputDatePicker() {
            if(this.formData.planifiedDate.date == false) return '';
            let dateNow = new Date()
            let dateFuture = new Date(this.formData.planifiedDate.date)
      
            if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                    if (dateFuture.getDay() === dateNow.getDay()) return "Aujourd'hui"
                    if (dateFuture.getDay() === dateNow.getDay()+1) return "Demain"
                    return dateFuture.toLocaleDateString(undefined, { weekday: 'long' });
                }
              
                if(dateFuture.getMonth() === dateNow.getMonth()) return dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric'});

                return dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });
            }
            return dateFuture.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'];
        },

     
    },
    watch: {
        ["formData.storification.stickers"]: {

            handler() {
                this.sortStickers()
            },
            deep: true,
            immediate: true
        },
        ["formData.planifiedDate.hours"](newValue, oldValue) {
            // Garde que les chiffres et les lettre h | garde que un seul 'h' | garde que 2 chiffre apres le h
            newValue = newValue.toLowerCase().replace(/^h|[^0-9h]|(h.{2}).*|h(.*?)h/gi, '$1$2');

            if (oldValue.length > newValue.length && oldValue.slice(-1) == "h") newValue = newValue.slice(0,-1)

            let valueSplit = newValue.split("h").slice(0, 2).map((vstr, i) => {
                if (!vstr.length) return vstr;
                if (vstr.length == 2 && vstr[0] == "0") return vstr
                let v = parseInt(vstr);
                v = i ? Math.min(v, 59) : Math.min(v, 23);
        
                return v < 10 ?
                    i && v > 5 ?
                        v.toString().padStart(2, '0')
                        : !i && v > 2 ?
                            v.toString().padStart(2, '0')
                            : v.toString()
                    : v.toString();
            });

            if (new Date().setHours(0,0,0,0) == new Date(this.formData.planifiedDate.date).setHours(0,0,0,0) && valueSplit.length == 2 && valueSplit[1].length == 2) {
                let dateNow = new Date(new Date().getTime() + 600000)
                if (parseInt(valueSplit[0]) <= dateNow.getHours()) {
                    valueSplit[0] = dateNow.getHours().toString().padStart(2, '0')
                    if (parseInt(valueSplit[1]) <= dateNow.getMinutes()) {
                        valueSplit[1] = dateNow.getMinutes().toString().padStart(2, '0')
                    }
                }
            }

            this.formData.planifiedDate.hours = valueSplit.length > 1 ? valueSplit.join('h') : valueSplit[0].length == 2 ? valueSplit[0]+'h' : valueSplit[0]
            this.calculTimeStampPlanifiedDate()

        },
        ["formData.planifiedDate.date"](newValue, oldValue) {
            if (!newValue || !newValue.length) {
                this.formData.planifiedDate.hours = false
                this.formData.planifiedDate.timestamp = false
            }else{
                //déclencher manuellement le watcher pour eviter une date a inferieur au jour actuel
                this.formData.planifiedDate.hours = this.formData.planifiedDate.hours +''
                this.calculTimeStampPlanifiedDate()
            }


        },

        ["formData.files"](newValue, oldValue) {
            this.$emit('saveFormData')
        },   
    },

    beforeDestroy() {
    },

}




</script>